"use strict";


// Burger menu
const navMenu = document.querySelector('#nav-menu'),
toggleMenu = document.querySelector('#toggle-menu'),
closeMenu = document.querySelector('#close-menu')
if(toggleMenu){
toggleMenu.addEventListener('click', () => {
    if(toggleMenu){
        navMenu.classList.toggle('show')
    }
})
closeMenu.addEventListener('click', () => {
    if(closeMenu){
        navMenu.classList.remove('show')
    }
})
}


//filtre
const elements = document.querySelectorAll('.no-local');
var toggleButton = document.querySelector("input");
if(toggleButton){
toggleButton.addEventListener("click", toggleCallback);

    for (const element of elements) {
        element.style.display = 'list-item';
      }
    toggleButton.checked = false;
}
function toggleCallback(){
    if(document.body.classList.toggle("dark")){
        for (const element of elements) {
            element.style.display = 'none';
          }
    }else{
          for (const element of elements) {
            element.style.display = 'list-item';
          }
    }
}
//recherche
function search() {
    let input = document.querySelector('#searchbar').value
    input=input.toLowerCase();
    let x = document.querySelectorAll('.beer__bar');
    console.log(x);
    let i  
    for (i = 0; i < x.length; i++) { 
        if (!x[i].innerHTML.toLowerCase().includes(input)) {
            x[i].style.display="none";
        }
        else {
            x[i].style.display="list-item";                 
        }
    }
}

//afficher map/list
let togg1 = document.querySelector("#togg1");
let togg2 = document.querySelector("#togg2");
let d1 = document.querySelector("#d1");
let d2 = document.querySelector("#d2");
if(togg1){
    togg1.addEventListener("click", () => {
    
        if(getComputedStyle(d1).display != "none"){
            d1.style.display = "block";
            d2.style.display = "none";
            togg1.classList.add("border");
            togg2.classList.remove("border");
          } 
          else {
            d1.style.display = "block";
            d2.style.display = "none";
            togg1.classList.add("border");
            togg2.classList.remove("border");
          } 
    
  
    })
}
if(togg1){
    togg2.addEventListener("click", () => {
        if(getComputedStyle(d2).display != "none"){
            d2.style.display = "block";
            d1.style.display = "none";
            togg2.classList.add("border");
            togg1.classList.remove("border");
        } 
        else {
            d2.style.display = "block";
            d1.style.display = "none";
            togg2.classList.add("border");
            togg1.classList.remove("border");
        }
    })
}
// The value for 'accessToken' begins with 'pk...'
const map_container = document.querySelector("#map");
if(map_container){
mapboxgl.accessToken = 'pk.eyJ1IjoibWFyYmV1aCIsImEiOiJja295MXF1bDcwN2N0MzBvMGYzaXYya2YxIn0.Ky0nyUIzByYpfgGFOHRJBA'; 
var map = new mapboxgl.Map({
  container: 'map',
  // Replace YOUR_STYLE_URL with your style URL.
  style: 'mapbox://styles/mapbox/streets-v11', 
  center: [4.69603,50.561466],
  zoom: 6
});

fetch('assets/js/items.json')
.then(res => {
    return res.json()
})
.then(items => {
    let listCard = document.querySelector('.list-card')
    listCard.innerHTML = ""
    items.map(item => {
      function slugify(str)
      {
          str = str.replace(/^\s+|\s+$/g, '');
      
          // Make the string lowercase
          str = str.toLowerCase();
      
          // Remove accents, swap ñ for n, etc
          var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
          var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
          for (var i=0, l=from.length ; i<l ; i++) {
              str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
          }
      
          // Remove invalid chars
          str = str.replace(/[^a-z0-9 -]/g, '') 
          // Collapse whitespace and replace by -
          .replace(/\s+/g, '-') 
          // Collapse dashes
          .replace(/-+/g, '-'); 
      
          return str;
      }
        var slug = slugify(item.title);
        const popup = new mapboxgl.Popup({ offset: 25 })
        .setHTML(
            `<a href="assets/bar/${slug}.html"><div class="content-popup"><h1>${item.title}</h1><p>${item.address}</p><p>${item.postalCode} ${item.city}</p></div></a>`
            );
        new mapboxgl.Marker({
            color:"#1f1f1f"
        })
        .setLngLat([item.lng, item.lat])
        .setPopup(popup)
        .addTo(map)
        let card = document.createElement('div')
        card.className = 'card'
        card.innerHTML = `
            <a href="assets/bar/${slug}.html">
                <div class="card-content">
                    <h1>${item.title}</h1>
                    <p>${item.address}</p>
                    <p>${item.postalCode} ${item.city}</p>
                </div>
            </a>
        `
        card.addEventListener('mouseenter', function(){
            let cursorItem = document.querySelector('#cursorItem')
            cursorItem.style.transform = `translateY(${this.offsetTop}px)`
            cursorItem.style.height = this.offsetHeight + "px"
            let markerHover = new mapboxgl.Marker({
                color:"#F1D035"
            })
            .setLngLat([item.lng, item.lat])
            .addTo(map)
            card.addEventListener('mouseleave', function(){
                markerHover.remove()
            })
        })

        listCard.append(card)
    })
})

}

  //=====  particles
  if (document.getElementById("particles-1"))
    particlesJS("particles-1", {
      particles: {
        number: {
          value: 40,
          density: {
            enable: !0,
            value_area: 4000,
          },
        },
        color: {
          value: ["#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        shape: {
          type: "circle",
          stroke: {
            width: 0,
            color: "#fff",
          },
          polygon: {
            nb_sides: 5,
          },
          image: {
            src: "img/github.svg",
            width: 33,
            height: 33,
          },
        },
        opacity: {
          value: 0.15,
          random: !0,
          anim: {
            enable: !0,
            speed: 0.2,
            opacity_min: 0.15,
            sync: !1,
          },
        },
        size: {
          value: 50,
          random: !0,
          anim: {
            enable: !0,
            speed: 2,
            size_min: 5,
            sync: !1,
          },
        },
        line_linked: {
          enable: !1,
          distance: 150,
          color: "#ffffff",
          opacity: 0.4,
          width: 1,
        },
        move: {
          enable: !0,
          speed: 1,
          direction: "top",
          random: !0,
          straight: !1,
          out_mode: "out",
          bounce: !1,
          attract: {
            enable: !1,
            rotateX: 600,
            rotateY: 600,
          },
        },
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: {
            enable: !1,
            mode: "bubble",
          },
          onclick: {
            enable: !1,
            mode: "repulse",
          },
          resize: !0,
        },
        modes: {
          grab: {
            distance: 400,
            line_linked: {
              opacity: 1,
            },
          },
          bubble: {
            distance: 250,
            size: 0,
            duration: 2,
            opacity: 0,
            speed: 3,
          },
          repulse: {
            distance: 400,
            duration: 0.4,
          },
          push: {
            particles_nb: 4,
          },
          remove: {
            particles_nb: 2,
          },
        },
      },
      retina_detect: !0,
    });

//WOW active
new WOW().init();    

//back to top btn
window.onscroll = function () {
    const backToTop = document.querySelector(".back-to-top");
    if (backToTop){
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        backToTop.style.display = "flex";
      } else {
        backToTop.style.display = "none";
      }
    }
    
}

var bouton1 = document.querySelector('#one')
var bouton2 = document.querySelector('#two')
var body = document.querySelector('body')
var modal_container1 = document.querySelector('#modal-container1')
var modal_container2 = document.querySelector('#modal-container2')

if(modal_container1){
bouton1.addEventListener("click",function onClick() {
  body.classList.add('modal-active')
  modal_container1.removeAttribute('class')
  modal_container1.classList.add('modal-container')
  modal_container1.classList.add('two')
})
modal_container1.addEventListener("click",function onClick() {
  this.classList.add('out')
  body.classList.remove('modal-active')
  
})
bouton2.addEventListener("click",function onClick() {
  body.classList.add('modal-active')
  modal_container2.removeAttribute('class')
  modal_container2.classList.add('modal-container')
  modal_container2.classList.add('two')
})
modal_container2.addEventListener("click",function onClick() {
  this.classList.add('out')
  body.classList.remove('modal-active')
  
})
}
